import subscriptionMessages from 'src/features/subscriptions/utils/messages';

import type { BadgeOptions } from 'src/types';

export const badgeSubscriptionStatusOptions: BadgeOptions = {
    active: {
        theme: 'emerald',
        label: subscriptionMessages.subscriptionActive,
    },
    upcoming: {
        theme: 'blue',
        label: subscriptionMessages.subscriptionUpcoming,
    },
    expired: {
        theme: 'red',
        label: subscriptionMessages.subscriptionExpired,
    },
};
